function IntroductionSection() {
  return (
    <section className="sections1" id="Introduction">
      <h1 className="Header">Introduction</h1>
      <p className="text-content">
        Hello and welcome to my website. My name is Saaketh Sodanapalli and I
        am currently a senior at UMass Amherst pursuing a B.S. in Computer
        Engineering and a dual degree in Mathematics.
      </p>
      <p className="text-content">
        I chose Computer Engineering because I wanted to understand both
        software and hardware deeply and build things from the ground up. Then, throughout college I grew enamoured with the applications and possibilities of AI, deciding to specialize in AI/ML. As a result, I
        added Mathematics with a Mathematical Computing concentration because it
        aligns with my long-term interests in AI and machine learning.
	My biggest interests currently are AI/ML, Robotics, and Software Dev.
      </p>
      <p className="text-content">
        Outside academics, I spend a lot of time exercising, including club swim
        at UMass, weightlifting, and recently running. I also have recently started to play chess a lot, with me hovering at around 1300 in chess.com. I also enjoy
        reading, especially sci-fi, and have recently been adding more
        non-fiction as well.
      </p>
      <p className="text-content">
        Below are selected projects, followed by contact information. I am
        always open to feedback on this website and opportunities to improve it.
	Hope you liked this website!
      </p>
    </section>
  );
}

export default IntroductionSection;
